import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@atenea-cms";
import { FlexLayoutModule } from "@angular/flex-layout";

import { AteneaModule } from "@atenea-cms";
import { CommonModule } from "../common";
import { ProductsRoutes } from "./products.routes";
import { ProductFilterBarComponent } from "./product-filter-bar/product-filter-bar.component";
import { ProductListComponent } from "./product-list/product-list.component";
import { ProductDetailComponent } from "./product-detail/product-detail.component";
import { ProductDetailGeneralComponent } from "./product-detail-general/product-detail-general.component";
import { ProductAwardFormComponent } from "./product-award-form/product-award-form.component";
import { ProductDownloadFormComponent } from "./product-download-form/product-download-form.component";
import { ProductFilterFormComponent } from "./product-filter-form/product-filter-form.component";
import { ProductHeaderFormComponent } from "./product-header-form/product-header-form.component";
import { ProductHighlightFormComponent } from "./product-highlight-form/product-highlight-form.component";
import { ProductHotPointFormComponent } from "./product-hot-point-form/product-hot-point-form.component";
import { ProductImageEffectFormComponent } from "./product-image-effect-form/product-image-effect-form.component";
import { ProductImageWithHotPointsFormComponent } from "./product-image-with-hot-points-form/product-image-with-hot-points-form.component";
import { ProductImageWithEffectsFormComponent } from "./product-image-with-effects-form/product-image-with-effects-form.component";
import { ProductPhotoForListFormComponent } from "./product-photo-for-list-form/product-photo-for-list-form.component";
import { ProductProminentFormComponent } from "./product-prominent-form/product-prominent-form.component";
import { ProductGalleryFormComponent } from "./product-gallery-form/product-gallery-form.component";
import { ProductWhereToBuyFormComponent } from "./product-where-to-buy-form/product-where-to-buy-form.component";
import { ProductSpecFormComponent } from "./product-spec-form/product-spec-form.component";
import { ProductSubSpecFormComponent } from "./product-sub-spec-form/product-sub-spec-form.component";
import { ProductSuggestedInCategoriesFormComponent } from "./product-suggested-in-categories-form/product-suggested-in-categories-form.component";
import { ProductSummaryFormComponent } from "./product-summary-form/product-summary-form.component";
import { ProductVideoFormComponent } from "./product-video-form/product-video-form.component";
import { ProductVideosFormComponent } from "./product-videos-form/product-videos-form.component";
import { ProductSoftwareFormComponent } from "./product-software-form/product-software-form.component";
import { ProductSoftwareSlideFormComponent } from "./product-software-slide-form/product-software-slide-form.component";
import {
  ProductService,
  ProductFormService,
  ProductFilterPipe,
} from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    FlexLayoutModule,
    AteneaModule,
    CommonModule,
    ProductsRoutes,
  ],
  declarations: [
    ProductFilterBarComponent,
    ProductListComponent,
    ProductDetailComponent,
    ProductDetailGeneralComponent,
    ProductAwardFormComponent,
    ProductDownloadFormComponent,
    ProductFilterFormComponent,
    ProductHeaderFormComponent,
    ProductHighlightFormComponent,
    ProductHotPointFormComponent,
    ProductImageEffectFormComponent,
    ProductImageWithHotPointsFormComponent,
    ProductImageWithEffectsFormComponent,
    ProductSpecFormComponent,
    ProductSubSpecFormComponent,
    ProductSuggestedInCategoriesFormComponent,
    ProductSummaryFormComponent,
    ProductPhotoForListFormComponent,
    ProductProminentFormComponent,
    ProductGalleryFormComponent,
    ProductVideoFormComponent,
    ProductVideosFormComponent,
    ProductSoftwareFormComponent,
    ProductSoftwareSlideFormComponent,
    ProductWhereToBuyFormComponent,
    ProductFilterPipe,
  ],
  providers: [ProductService, ProductFormService],
})
export class ProductsModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/products.module.ts